
// Metadata for the armpit rash and itching article
export const armpitRashItchyMetadata = {
  id: "armpit-rash-itchy",
  slug: "armpit-rash-itchy-causes-treatments",
  title: "Understanding Itchy Armpit Rashes: Causes, Symptoms and Treatment Options",
  excerpt: "Discover the common causes of itchy armpit rashes, from yeast infections to contact dermatitis, and learn effective treatment strategies for quick relief.",
  publishedAt: "July 10, 2023",
  readTime: "8 min read",
  category: "Health",
  image: "/lovable-uploads/a2ef7eb0-0c25-4d2e-885a-ecbd6e258b4a.png",
  metaDescription: "Learn about the causes of armpit rashes and itching, including yeast infections, contact dermatitis, and heat rash, along with effective treatments and prevention strategies.",
  keywords: ["armpit rash", "itchy armpits", "underarm rash", "armpit yeast infection", "contact dermatitis", "heat rash", "armpit irritation", "rash treatment"],
};
